import React, { useState, useEffect } from "react";
import { getRequest } from "../../apiWrapper";
import { filterStudentsFromGrade, gradeTabs } from "../../constants/gradeOptions";

const StudentSidebar = ({ isAdmin, selectedStudentId, onSelectStudent }) => {
  const [students, setStudents] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState("all");

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const data = await getRequest("students");
        if (data?.students) setStudents(data.students);
      } catch (error) {
        console.error("❌ 生徒取得エラー:", error);
      }
    };
    fetchStudents();
  }, []);

  useEffect(() => {
    if (!isAdmin) {
      const fetchAssignments = async () => {
        try {
          const data = await getRequest(`teacherAssignments`);
          if (data?.students) setAssignments(data.students);
        } catch (error) {
          console.error("❌ 担当生徒取得エラー:", error);
        }
      };
      fetchAssignments();
    }
  }, [isAdmin]);

  const filtered = filterStudentsFromGrade(students, selectedGrade);

  return (
    <div className="p-3">
      <div className="mb-4">
        <div className="flex flex-wrap gap-2">
          {gradeTabs.map((tab) => (
            <button
              key={tab.value}
              className={`px-3 py-1 rounded-full text-sm ${selectedGrade === tab.value ? "bg-blue-500 text-white" : "bg-gray-200"}`}
              onClick={() => setSelectedGrade(tab.value)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-2">
        {filtered
          .filter((s) => !s.withdrawn)
          .map((student) => (
            <button
              key={student.id}
              onClick={() => onSelectStudent(student.id)}
              className={`w-full text-left p-2 rounded-md border shadow-sm hover:bg-blue-50 transition ${
                student.id === selectedStudentId ? "bg-blue-100 border-blue-400" : "bg-white"
              }`}
            >
              {student.name}
            </button>
          ))}
      </div>
    </div>
  );
};

export default StudentSidebar;